import { FormType } from "../../interfaces/form-config.interface";

export const FORM_TYPE_ICONS: Record<FormType, string> = {
  [FormType.YACHT]:             "⛵",
  [FormType.BOAT]:              "🚤",
  [FormType.WATER_TOYS]:        "🏄",
  [FormType.ENGINE_GENERATOR]:  "⚙️",
  [FormType.PARTS_ACCESSORIES]: "🔧",
  [FormType.SERVICES]:          "🛠️",
  [FormType.SKILL_LABOUR]:      "👷",
  [FormType.CHARTER]:           "🗓️",
};
